// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2WT8O","content":"RecentSearches_content__1HKd1"};